import {AfterViewInit, Injector, OnDestroy, ViewChild, Directive, inject} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subject } from 'rxjs';
import { each } from 'lodash-es';

import {
  $invokeWatchers,
  noop,
  Viewport,
  ScriptLoaderService,
  UtilsService,
  registerFnByExpr
} from '@wm/core';
import { WidgetRef } from '@wm/components-base';
import { PageDirective } from '@wm/design-runtime';
// import {PrefabDirective} from '@wm/components/prefab';
import { I18nService } from '@wms/services';

import { FragmentMonitor } from '../util/fragment-monitor';
import {AppRef} from "@wms/app/design-container";
import { BaseVariableService } from "@wms/variables";

export const commonPartialWidgets = {};

@Directive()
export abstract class BasePartialComponent extends FragmentMonitor {
  Widgets: any;
  Actions: any;
  // injector: Injector;
  partialName: string;
  route: ActivatedRoute;
  router: Router;
  pageParams: any;
  containerWidget: any;
  i18nService: I18nService;
  // @ViewChild(PartialDirective) partialDirective;
  pageDirective: PageDirective;
  // Prefab: PrefabDirective;
  scriptLoaderService: ScriptLoaderService;
  Viewport: Viewport;
  compileContent = false;
  App: AppRef;
  private viewParent: any;
  destroy$ = new Subject();
  // override viewInit$ = new Subject();
  private baseVariableService: BaseVariableService;
  abstract evalUserScript(prefabContext: any, appContext: any, utils: any): any;

  abstract getVariables(): any;
  abstract getExpressions(): any;

  onPageContentReady: Function = noop;

  getContainerWidgetInjector() {
    return this.containerWidget.inj || this.containerWidget.injector;
  }

  override init() {

    // this.App = this.injector.get(App);
    this.App = inject(AppRef);
    this.containerWidget = inject(WidgetRef);
    this.i18nService = inject(I18nService);
    this.scriptLoaderService = inject(ScriptLoaderService);
    this.Viewport = inject(Viewport);
    this.viewParent = this.containerWidget.viewParent;
    this.baseVariableService = inject(BaseVariableService);
    if (this.viewParent.registerFragment) {
      this.viewParent.registerFragment();
    }

    // register functions for binding evaluation
    this.registerExpressions();
    this.initUserScript();

    this.registerWidgets();
    // this.initVariables();

    this.registerPageParams();

    this.defineI18nProps();

    this.viewInit$.subscribe(noop, noop, () => {
      this.pageParams = this.containerWidget.partialParams;
    });

    // this.pageDirective = this.injector.get(PageDirective, null);
    // if (this.pageDirective) {
    //   this.registerDestroyListener(this.pageDirective.subscribe('attach', (data: any) => this.ngOnAttach(data.refreshData)));
    //   this.registerDestroyListener(this.pageDirective.subscribe('detach', () => this.ngOnDetach()));
    // }

    super.init();
  }

  registerWidgets() {
    if (this.partialName === 'Common') {
      this.Widgets = commonPartialWidgets;
    } else {
      this.Widgets = Object.create(commonPartialWidgets);
    }

    this.containerWidget.Widgets = this.Widgets;
  }

  registerDestroyListener(fn: Function) {
    this.destroy$.subscribe(noop, noop, () => fn());
  }

  initUserScript() {
    try {
      // partials inside prefab should have access to Prefab properties and events
      if (this.viewParent.prefabName) {
        // for partial within partial within prefabs, just assign the parent partial's prefab object
        if (this.viewParent.Prefab) {
          // this.Prefab = this.viewParent.Prefab;
        } else {
          // this.Prefab = this.viewParent;
        }
      }
      this.evalUserScript(this, this.App, inject(UtilsService));
    } catch (e) {
      console.error(`Error in evaluating partial (${this.partialName}) script\n`, e);
    }
  }

  // initVariables() {
  //   const variablesService = this.injector.get(VariablesService);
  //
  //   // get variables and actions instances for the page
  //   const variableCollection = variablesService.register(this.partialName, this.getVariables(), this);
  //
  //   // create namespace for Variables nad Actions on page/partial, which inherits the Variables and Actions from App instance
  //   this.Variables = Object.create(this.App.Variables);
  //   this.Actions = Object.create(this.App.Actions);
  //
  //   this.containerWidget.Variables = this.Variables;
  //   this.containerWidget.Actions = this.Actions;
  //
  //   // assign all the page variables to the pageInstance
  //   Object.entries(variableCollection.Variables).forEach(([name, variable]) => this.Variables[name] = variable);
  //   Object.entries(variableCollection.Actions).forEach(([name, action]) => this.Actions[name] = action);
  //
  //
  //   this.viewInit$.subscribe(noop, noop, () => {
  //     // TEMP: triggering watchers so variables watching over params are updated
  //     $invokeWatchers(true, true);
  //     variableCollection.callback(variableCollection.Variables).catch(noop);
  //     variableCollection.callback(variableCollection.Actions);
  //   });
  // }

  /**
   * function to register bind expressions generated in this partial instance
   * getExpressions function is defined in the generated page.comp.ts file
   * @param expressions, map of bind expression vs generated function
   */
  registerExpressions() {
    const expressions = this.getExpressions();
    each(expressions, (fn, expr)=>{
      registerFnByExpr(expr, fn[0], fn[1]);
    });
  }

  registerPageParams() {
    this.pageParams = this.containerWidget.partialParams;
  }

  get appLocale() {
    return this.i18nService.appLocale;
  }

  defineI18nProps() {
    // this.appLocale = this.i18nService.appLocale;
  }

  invokeOnReady() {
    let params;
    if (this.containerWidget.userComponentParams) {
      params = this.containerWidget.userComponentParams;
    }
    // not invoking partial in studioMode
    // this.onReady(params);
    if (this.viewParent.resolveFragment) {
      this.viewParent.resolveFragment();
    }
  }

  private loadScripts() {
    return new Promise<void>((resolve) => {
      // const scriptsRequired = this.partialDirective.$element.attr('scripts-to-load');
      // if (scriptsRequired) {
      //   this.scriptLoaderService
      //     .load(...scriptsRequired.split(','))
      //     .then(resolve);
      // } else {
        resolve();
      // }
    });
  }

  mute() {
    const m = (o: any) => { o && o.mute && o.mute(); };
    each(this.Widgets, m);
    each(this.Variables, m);
    each(this.Actions, m);
  }

  unmute() {
    const um = (o: any) => { o && o.unmute && o.unmute(); };
    each(this.Widgets, um);
    each(this.Variables, um);
    each(this.Actions, um);
  }

  ngAfterViewInit(): void {
    this.loadScripts().then(() => {
      this.compileContent = true;
      setTimeout(() => {
        this.viewInit$.complete();

        this.fragmentsLoaded$.subscribe(noop, noop, () => this.invokeOnReady());

      }, 100);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
  }

  ngOnAttach(refreshData: any) {
    this.unmute();
    if (refreshData) {
      const refresh = (v: any) => { v && v.startUpdate && v.invoke && v.invoke(); };
      each(this.Variables, refresh);
      each(this.Actions, refresh);
    }
    each(this.Widgets, w => w && w.ngOnAttach && w.ngOnAttach());
  }

  ngOnDetach() {
    this.mute();
    each(this.Widgets, w => w && w.ngOnDetach && w.ngOnDetach());
  }

  onReady(params?: any) {
  }

  get Variables() {
    return this.baseVariableService.variableInstanceCollection[this.partialName];
  }
}
